import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import gsap from "gsap";
import "./styles/App.scss";

import Header from "./components/Header";
import Home from "./pages/home";

// pages
import CaseStudies from './pages/caseStudies';
import Approach from './pages/approach';
import Services from './pages/services';
import About from './pages/about';
import Contact from './pages/contact';
import Navigation from "./components/Navigation";

const routes = [
    {
        path: '/',
        name: 'Home',
        Component: Home
    },
    {
        path: '/case-studies',
        name: 'Case Studies',
        Component: CaseStudies
    },
    {
        path: '/how-we-work',
        name: 'Approach',
        Component: Approach
    },
    {
        path: '/services',
        name: 'Services',
        Component: Services
    },
    {
        path: '/about',
        name: 'About Us',
        Component: About
    },
    {
        path: '/contact',
        name: 'Contact',
        Component: Contact
    },
]

function debounce(fn, ms) {
    let timer;
    return () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            fn.apply(this, arguments);
        },ms);
    }
}

function App() {
    // visibility set to hiddden in app.scss. Once dom has loaded set to visible and that - STOP FLASH
    gsap.to('body', 0, { css: { visibility:"visible" }});
    // fix the responsive issue when the viewport changes
    const [dimensions, setDimensions] = useState({
        height:window.innerHeight,
        width:window.innerWidth
    });

    useEffect(() => {
        // grab the inner height of window for modile reasons when deailong with vh
        let vh = dimensions.height * .01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        const debounceHandleResize = debounce(function handleResize() {
            setDimensions({
                height:window.innerHeight,
                width:window.innerWidth
            })
        },1000)

        window.addEventListener('resize', debounceHandleResize);

        // cleanup function => remove eventListener

        return () => {
            window.removeEventListener('resize', debounceHandleResize);
        }

    },[])

    return (
        <>
            <Header dimensions={dimensions}/>
            {console.log(dimensions)}
            <div className="App">
                {routes.map(({path, Component}) => (
                    <Route key={path} exact path={path}>
                        <Component/>
                    </Route>
                ))}
            </div>
            <Navigation/>
        </>
    );
}

export default App;
